"use client";
import { useState } from "react";
import "./AIResponseBanner.css";

const safeStr = (v) => (v == null ? "" : String(v)).trim();

/**
 * Renders the AI-generated answer for a medical question.
 * Shared by the patient feed (PostCard), the patient "my questions" list
 * (QuestionCard) and the doctor "Medical Questions" list (DoctorQuestionsCard)
 * so all three views render it identically.
 */
export default function AIResponseBanner({ text, t }) {
  const [expanded, setExpanded] = useState(false);

  if (!safeStr(text)) return null;

  const title =
    t?.("postCard.aiResponse") === "postCard.aiResponse"
      ? "Réponse générée par IA"
      : t?.("postCard.aiResponse");

  const seeMoreLabel =
    t?.("postCard.seeMore") === "postCard.seeMore"
      ? "See more"
      : t?.("postCard.seeMore");

  const seeLessLabel =
    t?.("postCard.seeLess") === "postCard.seeLess"
      ? "See less"
      : t?.("postCard.seeLess");

  return (
    <div className="pcc-ai-banner">
      <div className="pcc-ai-banner__top">
        <div className="pcc-ai-banner__badge">AI</div>
        <div className="pcc-ai-banner__title">{title}</div>
      </div>

      <div className={`pcc-ai-banner__text ${expanded ? "expanded" : "collapsed"}`}>
        {text}
      </div>

      <button
        type="button"
        className="pcc-ai-see-more"
        onClick={() => setExpanded((v) => !v)}
      >
        {expanded ? seeLessLabel : seeMoreLabel}
      </button>

      <div className="pcc-ai-banner__footer">
        ⚠️ Cette réponse est informative et ne remplace pas un avis médical.
      </div>
    </div>
  );
}
